/**
 * The static return page — `/app-link/sign-in/finish` (plan-034 WAPP-APPSIGNIN; design §45.4 step 5; ADR 0089).
 *
 * On iPhone the return address is this page's address, which only the genuine wetalk app may claim: the browser sheet
 * hands it to the app. When the system did not capture it, the browser opens it here instead, and the page says only
 * "You can return to wetalk". It handles NO code: it reads nothing from its query, never draws a value from it, never
 * logs it; its route (`./app-sign-in-route.tsx`) takes the query out of the address bar at once, so the code lingers in
 * no history entry or screenshot.
 *
 * No `data-screen-label`: the prototype has no screen for it.
 */
import type { ReactNode } from "react";

import { portalText, usePortalTranslation } from "../../i18n/portal.js";
import { PublicFrame, PublicKicker } from "../auth/public-frame.js";

export const APP_SIGN_IN_FINISH_PATH = "/app-link/sign-in/finish";

export function AppSignInFinishScreen(): ReactNode {
  usePortalTranslation("appSignIn");
  return (
    <PublicFrame>
      <div className="pd-form">
        <PublicKicker>{portalText("appSignIn", "kicker")}</PublicKicker>
        <h1 tabIndex={-1}>{portalText("appSignIn", "finish.title")}</h1>
        <p className="pd-lede">{portalText("appSignIn", "finish.lede")}</p>
        <p className="pd-fine">{portalText("appSignIn", "finish.again")}</p>
      </div>
    </PublicFrame>
  );
}
